import HomeButton from "../Buttons/HomeButton"
import './HomeButtonsContainer.css'

const GALLERY_URL = "https://yardtofork.com/portfolio"

/**
 * 
 * @param {user} object example: "/info","/gallery"...
 * @returns JSX
 */
export default function HomeButtonsContainer({user}) {

  let firstButton = ['/', ""]
  let secondButton = ['/', ""]
  let thirdButton = ['/', ""]
  let fourthButton = ['/', ""]

  switch (user.role) {
    case 'admin':
      firstButton = ["/customers","Customers"]
      secondButton =  ["/edit-plants","Plants"]
      thirdButton = ["/","Messages"]
      fourthButton =  ["/employees","Employees"]
      break;
    case 'employee':
      firstButton = ["/customers","Customers"]
      secondButton = ["/edit-plants","Plants"]
      thirdButton = ["/","To Do"]
      fourthButton = ["/","Notes"]
      break;
    case 'customer':
      firstButton = ['/preferences','My Plants']
      secondButton = ['/info', 'Schedule Service']
      thirdButton = [GALLERY_URL, 'Gallery']
      fourthButton = ['/contact', 'Contact']
      break;
  
    default:
      break;
  }

  return (
    <div className="home-buttons-container">
      <div className="d-flex justify-content-center px-3 home-buttons-row">
        <HomeButton to={firstButton[0]} buttonName={firstButton[1]} />
        <HomeButton to={secondButton[0]} buttonName={secondButton[1]} />
      </div>
      <div className="d-flex justify-content-center flex-wrap px-3 pb-2 mb-1 home-buttons-row">
        {user?.role === 'customer' ? (
          <a
            href={thirdButton[0]}
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex flex-grow-1 home-page-link"
          >
            <button
              className="flex-grow-1 align-middle home-page-button"
              name={thirdButton[1]}
            >
              {thirdButton[1]}
            </button>
          </a>
        ) : (
          <HomeButton to={thirdButton[0]} buttonName={thirdButton[1]} />
        )}
        <HomeButton to={fourthButton[0]} buttonName={fourthButton[1]} />
      </div>
    </div>
  )
}


